import { useMemo } from 'react';
import { store as RRRStore } from 'redux-rest-reducer';

import { useAppSelector } from '@~/hooks';
import { type HomeDetailsData } from '@~/type-props/home-details';

const EMPTY_HOME_DETAILS = {} as HomeDetailsData;

const useStudentHomeDetails = (): HomeDetailsData => {
  const userId = useAppSelector(store => store.auth.userId);
  const homeDetails = useAppSelector(store => store.homeDetails);

  const studentHomeData = useMemo(
    () => RRRStore.get(homeDetails, userId)?.data || EMPTY_HOME_DETAILS,
    [homeDetails, userId],
  );

  return studentHomeData;
};

export default useStudentHomeDetails;
